import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]


export default /*@__PURE__*/_defineComponent({
  __name: 'HelpMarker',
  props: {
  helpPrompt: {
    type: String,
    required: true
  }
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  const _component_hy_icon = _resolveComponent("hy-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_component_v_tooltip, null, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_hy_icon, _mergeProps(props, {
        color: "primary",
        name: "Help",
        small: ""
      }), null, 16)
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: "help-prompt",
        innerHTML: __props.helpPrompt
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})